import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Button from 'components/theme/Button'
import { togglePreviewResponseView } from 'actions/signupForm/addOrEdit'
import { AppBar, Tabs, Tab, withStyles } from '@material-ui/core'

const ToggleViewButton = ({
	small,
	formID,
	viewSelected,
	togglePreviewResponseView,
	formTypeSelected,
	changeView,
	goBack,
	singleResDisplayed,
	classes,
}) => {
	if (singleResDisplayed) {
		return (
			<Button
				disabled={formID === 'new'}
				size={small ? 'small' : 'medium'}
				variant="contained"
				color="secondary"
				onClick={() => {
					goBack()
				}}
			>
				Go Back
			</Button>
		)
	}

	return (
		<AppBar
			classes={{ root: classes.appBarRoot }}
			position="static"
			color="default"
		>
			<Tabs
				value={viewSelected === 'preview' ? 0 : 1}
				onChange={(e, tabValue) => {
					if (tabValue === 0) {
						togglePreviewResponseView('preview')
					} else {
						togglePreviewResponseView('response')
					}
				}}
				indicatorColor="primary"
				textColor="primary"
				centered
			>
				<Tab label="Responses" />
				<Tab
					label={
						formTypeSelected === 'customIntegration' ? 'Fields' : 'Questions'
					}
				/>
			</Tabs>
		</AppBar>
	)
}

export default connect(
	(state) => ({
		formID: state.signupForm.addOrEdit.formID,
		viewSelected: state.signupForm.addOrEdit.previewResponseView,
		formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
	}),
	(dispatch) =>
		bindActionCreators(
			{
				togglePreviewResponseView,
			},
			dispatch,
		),
)(
	withStyles((theme) => ({
		appBarRoot: {
			borderRadius: 25,
		},
	}))(ToggleViewButton),
)
